import React from 'react';
import { reaction } from "mobx";
import { useContext, useEffect } from 'react';
//
import { Container, Typography } from '@mui/material';
//
import { AppContext } from '/@/app/AppContext';
import { ScrollContext } from '/@/app/AppLayout';
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout.jsx';
import Questionnaire from '/@/app/components/questionnaire/Questionnaire.jsx';

export const QuestionsView = ({ answeringMode }) => {

const {restoreScroll}=useContext(ScrollContext);

    if (answeringMode === undefined) {
        answeringMode = "all";
    }
    const { questionnaireSession } = useContext(AppContext);
    const session = questionnaireSession;
    useEffect(() => {
        session.setAnsweringMode(answeringMode);
        session.sectionList.fetchData();
    }, []);


useEffect(() =>
{
	const dispose = reaction(
		() => session.sectionList.preloading,
		(preloading) => { if (!preloading) requestAnimationFrame(() => { restoreScroll(); }); }
	);
	return dispose;
}, []);

    // closure to sections & refs, so other props can be passed in HelpingDrawerLayout
    const DrawerContent = ({ drawerOpen, setDrawerOpen }) => {
        reaction(() => session.nextNavigation, () => {
            setDrawerOpen(false);
        });
        return (
            <Questionnaire.Navigation session={session} />
        )
    }

    return <HelpingDrawerLayout
        drawerContent={DrawerContent}
        buttonText="Список"
    >
        <Container
            maxWidth="sm"
            sx={{
                padding: "0",
                position: "relative",
            }}
        >
            <Questionnaire.CurrentQuestion session={session} />
        </Container>
    </HelpingDrawerLayout>
}
